<template>
  <main class="content">
    <div class="row">
        <h1>
            Add new screensaver
        </h1>
    </div>
    <form novalidate v-on:submit.prevent="addScreenSaver" class="form">
        <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

        <fieldset class="form--item">
            <label class="label" for="">
                Youtube or Vimeo Link:
            </label>
            <div class="input_text" id="link">
                <input name="" required v-model="screensaver.link" placeholder="Paste a URL link from a Youtube or Vimeo video" type="text" value=""/>
            </div>
        </fieldset>
        <div class="row">
            <button class="btn btn_blue" type="submit">
                Add screensaver
            </button>
        </div>
    </form>
    <loading :visible.sync="loadingVisible"></loading>
</main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

export default {
  name: 'AddScreenSavers',
  components: {Message, Loading},
  mixins:[ValidateForm, CreateResource],

  data () {
    return {
      screensaver: {},
      resource: 'screensavers',
      parentResource: 'ScreenSavers',
      required_fields: [
        {'attribute': 'screensaver.link', 'message': 'Link is missing', 'id': 'link'}
      ]
    }
  },
  methods: {
    addScreenSaver(){
      this.createResource(this.screensaver);
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AddScreenSavers.vue?8183b14a